export enum ButtonType {
  PRIMARY = 'primary',
  GHOST = 'ghost',
  OUTLINE = 'outline',
  TRANSPARENT = 'transparent',
  DANGER = 'danger',
}
